import React, { useRef, useState } from "react";
import emailjs from "@emailjs/browser";
import "../styles/Modal.css";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faXmark } from "@fortawesome/free-solid-svg-icons";

const Modal = ({ show, onClose }) => {
  const form = useRef();
  const [emailSent, setEmailSent] = useState(false); // To track if the email was sent

  // const testing = true;

  if (!show) return null;

  const sendEmail = (e) => {
    e.preventDefault();

    // if (testing) {
    //   // Simulate email send success for testing
    //   setEmailSent(true);
    //   console.log("Email simulated!");
    //   return; // Skip the actual email sending
    // }

    emailjs
      .sendForm(
        "service_audzvl6",
        "template_vib8bb4",
        form.current,
        "y5-bK26nZxZRDjNa-"
      )
      .then(
        () => {
          setEmailSent(true); // Set emailSent to true when email is successfully sent
        },
        (error) => {
          console.log("FAILED...", error.text); // Handle error
        }
      );
  };

  return (
    <div className="modal-fullscreen">
      <nav className="modal-navbar">
        <div className="navbar-center">
          <h2>Auto DrivR School</h2>
        </div>
        <button className="close-button" onClick={onClose}>
          <FontAwesomeIcon icon={faXmark} />
        </button>
      </nav>

      {/* Main Content */}
      <div className="modal-content">
        {/* Left Section */}
        <div className="modal-left">
          <h3>Have any questions?</h3>
          <p className="subtext">Please send us an email.</p>

          <div className="modal-left-bottom">
            <p className="number">
              Alternatively, feel free to call or text at:
            </p>
            <p className="phone-number-form">
              <strong>07958142870</strong>
            </p>
          </div>
        </div>

        {/* Right Section */}
        <div className="modal-right">
          {!emailSent ? (
            <>
              <h3>Enquiry</h3>
              <form ref={form} onSubmit={sendEmail}>
                <input
                  type="text"
                  name="user_name"
                  placeholder="NAME*"
                  required
                />
                <input
                  type="email"
                  name="user_email"
                  placeholder="EMAIL*"
                  required
                />
                <textarea name="message" placeholder="MESSAGE*" required />
                <input type="submit" value="Submit" className="submit" />
              </form>
            </>
          ) : (
            <div className="email-sent-message">
              <h3>
                Thank you! <br />
                Your email has been sent successfully.
              </h3>
              <p>We'll get back to you shortly.</p>
            </div>
          )}
        </div>
      </div>
    </div>
  );
};

export default Modal;
